import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { Derogation } from '@classes/derogation/derogation';

@Injectable({
    providedIn: 'root'
})
export class DerogationService {
    private baseUrl = environment.apiUrl + 'derogations';

    constructor(
        private http: HttpClient
    ) { }

    get(): Observable<Derogation[]> {
        return this.http.get<Derogation[]>(this.baseUrl);
    }

    post(derogations: Derogation[]): Observable<void> {
        return this.http.post<void>(this.baseUrl, derogations);
    }

    reset(): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/reset`, null);
    }
}
